/**
 * Checklist hub SEO metadata (Milestone 14).
 */
import { getChecklistNoindexDecision } from "./noindexRules";
import { buildBreadcrumbJsonLd, combineStructuredData } from "./structuredData";
import { AUTOMAPA_DEFAULT_OG_IMAGE, PUBLIC_CHECKLIST_PATH } from "./seoConstants";
import { buildMetaDescription, buildPageTitle, buildSeoBundle, robotsDirective } from "./seoUtils";

export function getChecklistSeo({ hasVehicleQueryContext = false } = {}) {
  const noindexDecision = getChecklistNoindexDecision({ hasVehicleQueryContext });

  const bundle = buildSeoBundle({
    title: buildPageTitle("Checklist para comprar carro usado en Colombia"),
    description: buildMetaDescription(
      "Revisa disponibilidad, precio, kilometraje, documentos, SOAT, tecnomecánica, peritaje y traspaso antes de comprar un carro usado en Colombia."
    ),
    canonicalPath: PUBLIC_CHECKLIST_PATH,
    robots: robotsDirective(noindexDecision.shouldIndex, { follow: noindexDecision.follow }),
    image: AUTOMAPA_DEFAULT_OG_IMAGE,
  });

  const breadcrumbs = [
    { label: "Inicio", href: "/" },
    { label: "Checklist de compra", href: PUBLIC_CHECKLIST_PATH },
  ];

  return {
    ...bundle,
    noindex: !noindexDecision.shouldIndex,
    noindexReason: noindexDecision.reason,
    breadcrumbs,
    structuredData: combineStructuredData(buildBreadcrumbJsonLd(breadcrumbs)),
  };
}
